import styled from 'styled-components';

export const Container = styled.div`
  padding-bottom: 20px;
`;

export const Header = styled.div`
  margin: 0 -16px;
  margin-bottom: 10px;
  padding: 15px;
  background-color: white;
  display: flex;
  align-items: flex-end;
  gap: 6px;
`;

export const Main = styled.div`
  flex: 1 1 auto;
  overflow: hidden;
`;

export const SummaryContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  margin: 0 -16px;
  padding: 5px 16px 16px 16px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  
  &::-webkit-scrollbar {
    height: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 2px;
  }
`;